var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SignifyClient, ready, randomPasscode, Tier, Serder, Algos, d, messagize, Siger, Saider, Salter } from 'signify-ts';
import { entropyToMnemonic, mnemonicToEntropy } from "bip39";
import { waitOperation, hasEndRole, resolveOobi, createTimestamp, markAndRemoveNotification, getStates, removeNullOrUndefined } from './utils';
export { isPasskeySupported, hasLocalPasskeyLink, setupPasskey, loginWithPasskey, unlinkPasskey } from './passkey';
var client;
export function resetSignifyClient() {
    client = undefined;
}
export function validatePasscode(keriAdminUrl, keriBootUrl, passCode) {
    return __awaiter(this, void 0, void 0, function () {
        var tempClient, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ready()];
                case 1:
                    _b.sent();
                    passCode = passCode.padEnd(21, '_');
                    tempClient = new SignifyClient(keriAdminUrl, passCode, Tier.low, keriBootUrl);
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, tempClient.connect()];
                case 3:
                    _b.sent();
                    return [2 /*return*/, true];
                case 4:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function generatePasscode() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ready()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, randomPasscode()];
            }
        });
    });
}
export function generateRecoveryWords(passcode) {
    return __awaiter(this, void 0, void 0, function () {
        var passcodeBytes;
        return __generator(this, function (_a) {
            passcodeBytes = Buffer.concat([
                Buffer.from(passcode, "utf-8"),
                Buffer.alloc(3),
            ]);
            return [2 /*return*/, entropyToMnemonic(passcodeBytes)];
        });
    });
}
export function recoverPasscode(recoveryWords) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Buffer.from(mnemonicToEntropy(recoveryWords), "hex")
                    .toString("utf-8")
                    .replace(/\0/g, "")];
        });
    });
}
export function initSignifyClient(keriAdminUrl, keriBootUrl, passCode) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (client) {
                        console.log('Client already initialised');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, ready()];
                case 1:
                    _a.sent();
                    passCode = passCode.padEnd(21, '_');
                    client = new SignifyClient(keriAdminUrl, passCode, Tier.low, keriBootUrl);
                    return [2 /*return*/];
            }
        });
    });
}
export function connectToAgent() {
    return __awaiter(this, arguments, void 0, function (timeoutMs) {
        var failure, connectPromise, timeoutPromise, _a;
        if (timeoutMs === void 0) { timeoutMs = 120000; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    failure = { success: false, controllerAid: null, agentAid: null };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    connectPromise = client.connect()
                        .then(function () { return ({
                        success: true,
                        controllerAid: client.controller.pre,
                        agentAid: client.agent.pre
                    }); })
                        .catch(function () { return failure; });
                    timeoutPromise = new Promise(function (resolve) {
                        return setTimeout(function () { return resolve(failure); }, timeoutMs);
                    });
                    return [4 /*yield*/, Promise.race([connectPromise, timeoutPromise])];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, failure];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function bootNewAgent() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.boot()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function getIdentifiers() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.identifiers().list()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getOobi(alias, role) {
    return __awaiter(this, void 0, void 0, function () {
        var oobi;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.oobis().get(alias, role)];
                case 1:
                    oobi = _a.sent();
                    return [2 /*return*/, oobi.oobis[0]];
            }
        });
    });
}
export function createIdentifier(alias, delegatorAid) {
    return __awaiter(this, void 0, void 0, function () {
        var args, result, op, eid, addRoleResult, addRoleOp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    args = {
                        delpre: delegatorAid
                    };
                    return [4 /*yield*/, client.identifiers().create(alias, args)];
                case 1:
                    result = _b.sent();
                    return [4 /*yield*/, result.op()];
                case 2:
                    op = _b.sent();
                    return [4 /*yield*/, waitOperation(client, op)];
                case 3:
                    op = _b.sent();
                    eid = (_a = client.agent) === null || _a === void 0 ? void 0 : _a.pre;
                    return [4 /*yield*/, client.identifiers().addEndRole(alias, 'agent', eid)];
                case 4:
                    addRoleResult = _b.sent();
                    return [4 /*yield*/, addRoleResult.op()];
                case 5:
                    addRoleOp = _b.sent();
                    return [4 /*yield*/, waitOperation(client, addRoleOp)];
                case 6:
                    addRoleOp = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function getOrCreateIdentifier(alias) {
    return __awaiter(this, void 0, void 0, function () {
        var id, isNew, identifier, _a, result, op, eid, hasAgentRole, result, op, oobi;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, client.identifiers().get(alias)];
                case 1:
                    identifier = _c.sent();
                    id = identifier.prefix;
                    isNew = false;
                    return [3 /*break*/, 7];
                case 2:
                    _a = _c.sent();
                    return [4 /*yield*/, client.identifiers().create(alias)];
                case 3:
                    result = _c.sent();
                    return [4 /*yield*/, result.op()];
                case 4:
                    op = _c.sent();
                    return [4 /*yield*/, waitOperation(client, op)];
                case 5:
                    op = _c.sent();
                    return [4 /*yield*/, client.identifiers().get(alias)];
                case 6:
                    identifier = _c.sent();
                    id = identifier.prefix;
                    isNew = true;
                    return [3 /*break*/, 7];
                case 7:
                    if (!!identifier.group) return [3 /*break*/, 12];
                    eid = (_b = client.agent) === null || _b === void 0 ? void 0 : _b.pre;
                    return [4 /*yield*/, hasEndRole(client, alias, 'agent', eid)];
                case 8:
                    hasAgentRole = _c.sent();
                    if (!!hasAgentRole) return [3 /*break*/, 12];
                    return [4 /*yield*/, client.identifiers().addEndRole(alias, 'agent', eid)];
                case 9:
                    result = _c.sent();
                    return [4 /*yield*/, result.op()];
                case 10:
                    op = _c.sent();
                    return [4 /*yield*/, waitOperation(client, op)];
                case 11:
                    op = _c.sent();
                    _c.label = 12;
                case 12: return [4 /*yield*/, client.oobis().get(alias, 'agent')];
                case 13:
                    oobi = _c.sent();
                    return [2 /*return*/, {
                            isNew: isNew,
                            aid: id,
                            oobi: oobi.oobis[0]
                        }];
            }
        });
    });
}
export function addWitnesses(alias, witnesses) {
    return __awaiter(this, void 0, void 0, function () {
        var _i, witnesses_1, witness, oobi, witnessAids, opResult, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _i = 0, witnesses_1 = witnesses;
                    _c.label = 1;
                case 1:
                    if (!(_i < witnesses_1.length)) return [3 /*break*/, 4];
                    witness = witnesses_1[_i];
                    oobi = witness.url + "/oobi/".concat(witness.aid, "/controller");
                    return [4 /*yield*/, resolveOobi(client, oobi, witness.name)];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    witnessAids = witnesses.map(function (witness) { return witness.aid; });
                    return [4 /*yield*/, client.identifiers().rotate(alias, { adds: witnessAids })];
                case 5:
                    opResult = _c.sent();
                    _a = waitOperation;
                    _b = [client];
                    return [4 /*yield*/, opResult.op()];
                case 6: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                case 7:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function interact(aid, data) {
    return __awaiter(this, void 0, void 0, function () {
        var jsonData, result, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    jsonData = JSON.parse(data);
                    return [4 /*yield*/, client.identifiers().interact(aid, jsonData)];
                case 1:
                    result = _c.sent();
                    _a = waitOperation;
                    _b = [client];
                    return [4 /*yield*/, result.op()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                case 3:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function resolve(oobi, alias) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveOobi(client, oobi, alias)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getContacts() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.contacts().list()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getContact(aid) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.contacts().get(aid)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function deleteContact(contactAid) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.contacts().delete(contactAid)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function generateChallenge() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.challenges().generate(128)];
                case 1: return [2 /*return*/, (_a.sent()).words];
            }
        });
    });
}
export function addDataToContact(contactAid, key, value) {
    return __awaiter(this, void 0, void 0, function () {
        var contact;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.contacts().get(contactAid)];
                case 1:
                    contact = _a.sent();
                    contact[key] = value;
                    return [4 /*yield*/, client.contacts().update(contactAid, contact)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function getDataFromContact(contactId, key) {
    return __awaiter(this, void 0, void 0, function () {
        var contact;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.contacts().get(contactId)];
                case 1:
                    contact = _a.sent();
                    return [2 /*return*/, contact[key]];
            }
        });
    });
}
export function respondToChallenge(aid, recipientAid, words) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.challenges().respond(aid, recipientAid, words)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function verifyChallenge(recipientAid, words) {
    return __awaiter(this, void 0, void 0, function () {
        var op, response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, client.challenges().verify(recipientAid, words)];
                case 1:
                    op = _c.sent();
                    return [4 /*yield*/, waitOperation(client, op)];
                case 2:
                    op = _c.sent();
                    response = op.response;
                    return [2 /*return*/, (_b = (_a = response.exn) === null || _a === void 0 ? void 0 : _a.d) !== null && _b !== void 0 ? _b : ''];
            }
        });
    });
}
export function markChallengeResponded(recipientAid, challengeSaid) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.challenges().responded(recipientAid, challengeSaid)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function getSchemas() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.schemas().list()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getSchema(said) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.schemas().get(said)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function isSchemaResolved(said) {
    return __awaiter(this, void 0, void 0, function () {
        var schema, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, client.schemas().get(said)];
                case 1:
                    schema = _b.sent();
                    return [2 /*return*/, !!schema && typeof schema.$id === 'string'];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Resolves a schema OOBI and verifies the schema is actually present in this
// agent's cache before returning. KERIA's cloneCreds walks the full edge chain
// of a credential and throws 'NoneType has no attribute sed' (500) if ANY schema
// in that chain is missing, which makes GET /credentials fail and every credential
// vanish from the wallet. Fire-and-forget OOBI resolution is unreliable against a
// transient schema server, so we verify and retry here.
export function resolveSchema(said, oobi) {
    return __awaiter(this, void 0, void 0, function () {
        var maxAttempts, _loop_1, attempt, state_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    maxAttempts = 8;
                    _loop_1 = function (attempt) {
                        var err_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, isSchemaResolved(said)];
                                case 1:
                                    if (_b.sent()) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    _b.label = 2;
                                case 2:
                                    _b.trys.push([2, 4, , 5]);
                                    return [4 /*yield*/, resolveOobi(client, oobi)];
                                case 3:
                                    _b.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _b.sent();
                                    if (attempt === maxAttempts) {
                                        throw err_1;
                                    }
                                    return [3 /*break*/, 5];
                                case 5: return [4 /*yield*/, isSchemaResolved(said)];
                                case 6:
                                    if (_b.sent()) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, Math.min(1000 * attempt, 5000)); })];
                                case 7:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    attempt = 1;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= maxAttempts)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(attempt)];
                case 2:
                    state_1 = _a.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _a.label = 3;
                case 3:
                    attempt++;
                    return [3 /*break*/, 1];
                case 4: return [4 /*yield*/, isSchemaResolved(said)];
                case 5:
                    if (!(_a.sent())) {
                        throw new Error("Schema ".concat(said, " could not be resolved after ").concat(maxAttempts, " attempts"));
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function getSchemaEdges(said) {
    return __awaiter(this, void 0, void 0, function () {
        var schema, edgeBlock, edgeProps, requiredEdges, results, _i, requiredEdges_1, name_1, edgeDef, parentSchemaSaid, operator;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0: return [4 /*yield*/, client.schemas().get(said)];
                case 1:
                    schema = _o.sent();
                    edgeBlock = (_a = schema === null || schema === void 0 ? void 0 : schema.properties) === null || _a === void 0 ? void 0 : _a.e;
                    if (!edgeBlock) {
                        return [2 /*return*/, []];
                    }
                    edgeProps = (_c = (_b = edgeBlock === null || edgeBlock === void 0 ? void 0 : edgeBlock.oneOf) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.properties;
                    if (!edgeProps) {
                        return [2 /*return*/, []];
                    }
                    requiredEdges = (_f = (_e = (_d = edgeBlock === null || edgeBlock === void 0 ? void 0 : edgeBlock.oneOf) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.required) !== null && _f !== void 0 ? _f : [];
                    results = [];
                    for (_i = 0, requiredEdges_1 = requiredEdges; _i < requiredEdges_1.length; _i++) {
                        name_1 = requiredEdges_1[_i];
                        if (name_1 === 'd')
                            continue;
                        edgeDef = edgeProps[name_1];
                        parentSchemaSaid = (_j = (_h = (_g = edgeDef === null || edgeDef === void 0 ? void 0 : edgeDef.properties) === null || _g === void 0 ? void 0 : _g.s) === null || _h === void 0 ? void 0 : _h.const) !== null && _j !== void 0 ? _j : '';
                        operator = (_m = (_l = (_k = edgeDef === null || edgeDef === void 0 ? void 0 : edgeDef.properties) === null || _k === void 0 ? void 0 : _k.o) === null || _l === void 0 ? void 0 : _l.const) !== null && _m !== void 0 ? _m : '';
                        results.push({ name: name_1, parentSchemaSaid: parentSchemaSaid, operator: operator });
                    }
                    return [2 /*return*/, results];
            }
        });
    });
}
export function createRegistry(alias, registryName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.registries().create({ name: alias, registryName: registryName })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function getRegistries(alias) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.registries().list(alias)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getOrCreateRegistry(alias, registryName) {
    return __awaiter(this, void 0, void 0, function () {
        var registries, registry, ex_1, createRegistryResult, operationDetails, completedOperation, registrySaid;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 6]);
                    return [4 /*yield*/, client.registries().list(alias)];
                case 1:
                    registries = _c.sent();
                    registry = registries.find(function (r) { return r.name === registryName; });
                    if (!registry) {
                        throw new Error("Registry with name ".concat(registryName, " not found for alias ").concat(alias));
                    }
                    return [2 /*return*/, registry.regk];
                case 2:
                    ex_1 = _c.sent();
                    return [4 /*yield*/, client
                            .registries()
                            .create({ name: alias, registryName: registryName })];
                case 3:
                    createRegistryResult = _c.sent();
                    return [4 /*yield*/, createRegistryResult.op()];
                case 4:
                    operationDetails = _c.sent();
                    return [4 /*yield*/, client
                            .operations()
                            .wait(operationDetails, { signal: AbortSignal.timeout(30000) })];
                case 5:
                    completedOperation = _c.sent();
                    registrySaid = (_b = (_a = completedOperation === null || completedOperation === void 0 ? void 0 : completedOperation.response) === null || _a === void 0 ? void 0 : _a.anchor) === null || _b === void 0 ? void 0 : _b.i;
                    return [2 /*return*/, registrySaid];
                case 6: return [2 /*return*/];
            }
        });
    });
}
export function issueCredentialOld(issuerAlias, vcData, registryRegk, schemaSaid, holderAid) {
    return __awaiter(this, void 0, void 0, function () {
        var vcDataJson, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    vcDataJson = JSON.parse(vcData);
                    return [4 /*yield*/, client
                            .credentials()
                            .issue(issuerAlias, {
                            ri: registryRegk,
                            s: schemaSaid,
                            a: __assign({ i: holderAid }, vcDataJson),
                        })];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, waitOperation(client, result.op)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, {
                            credentialId: result.acdc.ked.d,
                            raw: JSON.stringify(result, null, 2)
                        }];
            }
        });
    });
}
export function issueCredential(issuerAlias, credentialClaims, registryRegk, schemaSaid, holderAid, edges, rules) {
    return __awaiter(this, void 0, void 0, function () {
        var credentialData, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    credentialData = {
                        ri: registryRegk,
                        s: schemaSaid,
                        u: new Salter({}).qb64,
                        a: __assign({ i: holderAid }, credentialClaims)
                    };
                    if (edges) {
                        credentialData.e = Saider.saidify(edges)[1];
                    }
                    if (rules) {
                        credentialData.r = Saider.saidify(rules)[1];
                    }
                    return [4 /*yield*/, client
                            .credentials()
                            .issue(issuerAlias, credentialData)];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, waitOperation(client, result.op)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, result.acdc.ked.d];
            }
        });
    });
}
export function sendCredentialGrant(credentialId, issuerAlias, recipientAid, message) {
    return __awaiter(this, void 0, void 0, function () {
        var credential, holderAid, ancatc, _a, grant, gsigs, gend, op;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.credentials().get(credentialId)];
                case 1:
                    credential = _b.sent();
                    holderAid = recipientAid !== null && recipientAid !== void 0 ? recipientAid : credential.sad.a.i;
                    ancatc = credential.ancatc;
                    return [4 /*yield*/, client.ipex().grant({
                            senderName: issuerAlias,
                            acdc: new Serder(credential.sad),
                            anc: new Serder(credential.anc),
                            iss: new Serder(credential.iss),
                            ancAttachment: Array.isArray(ancatc) ? ancatc.join('') : ancatc,
                            recipient: holderAid,
                            datetime: createTimestamp(),
                            message: message !== null && message !== void 0 ? message : '',
                        })];
                case 2:
                    _a = _b.sent(), grant = _a[0], gsigs = _a[1], gend = _a[2];
                    return [4 /*yield*/, client.ipex().submitGrant(issuerAlias, grant, gsigs, gend, [holderAid])];
                case 3:
                    op = _b.sent();
                    return [4 /*yield*/, waitOperation(client, op)];
                case 4:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function admitCredentialGrant(noteId, grantSaid, issuerAid, holderAlias) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, admit, sigs, aend, op, count;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.ipex().admit({
                        senderName: holderAlias,
                        message: '',
                        grantSaid: grantSaid,
                        recipient: issuerAid,
                        datetime: createTimestamp(),
                    })];
                case 1:
                    _a = _b.sent(), admit = _a[0], sigs = _a[1], aend = _a[2];
                    return [4 /*yield*/, client.ipex().submitAdmit(holderAlias, admit, sigs, aend, [issuerAid])];
                case 2:
                    op = _b.sent();
                    return [4 /*yield*/, waitOperation(client, op)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, markAndRemoveNotification(client, noteId)];
                case 4:
                    _b.sent();
                    return [4 /*yield*/, client.credentials().list()];
                case 5:
                    count = (_b.sent()).length;
                    console.log('[admitCredentialGrant] credential count after admit:', count);
                    return [2 /*return*/];
            }
        });
    });
}
export function getCredentialsAsString() {
    return __awaiter(this, void 0, void 0, function () {
        var credentials;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.credentials().list()];
                case 1:
                    credentials = _a.sent();
                    credentials.forEach(function (credential) {
                        delete credential.chains;
                    });
                    return [2 /*return*/, JSON.stringify(credentials, null, 2)];
            }
        });
    });
}
export function getCredentials(filter) {
    return __awaiter(this, void 0, void 0, function () {
        var MAX_RETRIES, RETRY_DELAY_MS, attempt, credentials;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    MAX_RETRIES = 5;
                    RETRY_DELAY_MS = 1500;
                    attempt = 1;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= MAX_RETRIES)) return [3 /*break*/, 8];
                    credentials = void 0;
                    if (!filter) return [3 /*break*/, 3];
                    removeNullOrUndefined(filter);
                    if (filter.filter) {
                        removeNullOrUndefined(filter.filter);
                    }
                    return [4 /*yield*/, client.credentials().list(filter)];
                case 2:
                    credentials = _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, client.credentials().list()];
                case 4:
                    credentials = _a.sent();
                    _a.label = 5;
                case 5:
                    credentials.forEach(function (credential) {
                        delete credential.chains;
                    });
                    // If we have a filter, don't retry — an empty result is a valid answer.
                    if (credentials.length > 0 || filter || attempt === MAX_RETRIES) {
                        return [2 /*return*/, credentials];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, RETRY_DELAY_MS); })];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    attempt++;
                    return [3 /*break*/, 1];
                case 8: return [2 /*return*/, []];
            }
        });
    });
}
export function getNotifications(route) {
    return __awaiter(this, void 0, void 0, function () {
        var result, notifications;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.notifications().list()];
                case 1:
                    result = _a.sent();
                    if (route) {
                        notifications = result.notes.filter(function (note) { return note.a.r === route && note.r === false; });
                    }
                    else {
                        notifications = result.notes.filter(function (note) { return note.r === false; });
                    }
                    return [2 /*return*/, {
                            notifications: notifications,
                            raw: JSON.stringify(result, null, 2)
                        }];
            }
        });
    });
}
export function getExchangeMessage(said) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.exchanges().get(said)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function getIdentifier(aid) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.identifiers().get(aid)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function getKeyEvents(aid) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.keyEvents().get(aid)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function getKeyStates(aid) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.keyStates().get(aid)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function getState() {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.state()];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function startMultisigIncept(_a) {
    return __awaiter(this, void 0, void 0, function () {
        var aid1, participantStates, icpResult1, op1, serder, sigs, sigers, ims, atc, embeds, smids;
        var groupName = _a.groupName, localMemberName = _a.localMemberName, participants = _a.participants, args = __rest(_a, ["groupName", "localMemberName", "participants"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.identifiers().get(localMemberName)];
                case 1:
                    aid1 = _b.sent();
                    return [4 /*yield*/, getStates(client, participants)];
                case 2:
                    participantStates = _b.sent();
                    return [4 /*yield*/, client.identifiers().create(groupName, {
                            algo: Algos.group,
                            mhab: aid1,
                            isith: args.isith,
                            nsith: args.nsith,
                            toad: args.toad,
                            wits: args.wits,
                            delpre: args.delpre,
                            states: participantStates,
                            rstates: participantStates,
                        })];
                case 3:
                    icpResult1 = _b.sent();
                    return [4 /*yield*/, icpResult1.op()];
                case 4:
                    op1 = _b.sent();
                    serder = icpResult1.serder;
                    sigs = icpResult1.sigs;
                    sigers = sigs.map(function (sig) { return new Siger({ qb64: sig }); });
                    ims = d(messagize(serder, sigers));
                    atc = ims.substring(serder.size);
                    embeds = {
                        icp: [serder, atc],
                    };
                    smids = participantStates.map(function (state) { return state['i']; });
                    return [4 /*yield*/, client
                            .exchanges()
                            .send(localMemberName, groupName, aid1, '/multisig/icp', { gid: serder.pre, smids: smids, rmids: smids }, embeds, participants)];
                case 5:
                    _b.sent();
                    //const members = await client.identifiers().members(groupName);
                    //const eid1 = Object.keys(members.signing[0].ends.agent)[0];
                    //const endRoleOperation1 = await client.identifiers().addEndRole(groupName, 'agent', eid1);
                    //await waitOperation(client, await endRoleOperation1.op());
                    return [2 /*return*/, JSON.stringify(op1, null, 2)];
            }
        });
    });
}
export function acceptMultisigIncept(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var memberHab, res, exn, icp, smids, rmids, states, rstates, icpResult2, op2, serder, sigs, sigers, ims, atc, embeds, recipients;
        var groupName = _b.groupName, localMemberName = _b.localMemberName, msgSaid = _b.msgSaid, notificationId = _b.notificationId;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, client.identifiers().get(localMemberName)];
                case 1:
                    memberHab = _c.sent();
                    return [4 /*yield*/, client.groups().getRequest(msgSaid)];
                case 2:
                    res = _c.sent();
                    exn = res[0].exn;
                    icp = exn.e.icp;
                    smids = exn.a.smids;
                    rmids = exn.a.rmids;
                    return [4 /*yield*/, getStates(client, smids)];
                case 3:
                    states = _c.sent();
                    return [4 /*yield*/, getStates(client, rmids)];
                case 4:
                    rstates = _c.sent();
                    return [4 /*yield*/, client.identifiers().create(groupName, {
                            algo: Algos.group,
                            mhab: memberHab,
                            isith: icp.kt,
                            nsith: icp.nt,
                            toad: parseInt(icp.bt),
                            wits: icp.b,
                            states: states,
                            rstates: rstates,
                            delpre: icp.di,
                        })];
                case 5:
                    icpResult2 = _c.sent();
                    return [4 /*yield*/, icpResult2.op()];
                case 6:
                    op2 = _c.sent();
                    serder = icpResult2.serder;
                    sigs = icpResult2.sigs;
                    sigers = sigs.map(function (sig) { return new Siger({ qb64: sig }); });
                    ims = d(messagize(serder, sigers));
                    atc = ims.substring(serder.size);
                    embeds = {
                        icp: [serder, atc],
                    };
                    recipients = smids.filter(function (id) { return memberHab.prefix !== id; });
                    client
                        .exchanges()
                        .send(localMemberName, groupName, memberHab, '/multisig/icp', { gid: serder.pre, smids: smids, rmids: smids }, embeds, recipients);
                    //const members = await client.identifiers().members(groupName);
                    //const eid1 = Object.keys(members.signing[1].ends.agent)[0];
                    //const endRoleOperation1 = await client.identifiers().addEndRole(groupName, 'agent', eid1);
                    //await waitOperation(client, await endRoleOperation1.op());
                    return [4 /*yield*/, markAndRemoveNotification(client, notificationId)];
                case 7:
                    //const members = await client.identifiers().members(groupName);
                    //const eid1 = Object.keys(members.signing[1].ends.agent)[0];
                    //const endRoleOperation1 = await client.identifiers().addEndRole(groupName, 'agent', eid1);
                    //await waitOperation(client, await endRoleOperation1.op());
                    _c.sent();
                    return [2 /*return*/, JSON.stringify(op2, null, 2)];
            }
        });
    });
}
export function getGroupRequest(messageSaid) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.groups().getRequest(messageSaid)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function createDelegateIdentifier(delegatorAid) {
    return __awaiter(this, void 0, void 0, function () {
        var icpResult, op;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client
                        .identifiers()
                        .create('delegate', { delpre: delegatorAid })];
                case 1:
                    icpResult = _a.sent();
                    return [4 /*yield*/, icpResult.op()];
                case 2:
                    op = _a.sent();
                    return [2 /*return*/, JSON.stringify(op, null, 2)];
            }
        });
    });
}
export function approveDelegation(alias, anchor) {
    return __awaiter(this, void 0, void 0, function () {
        var result, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, client.delegations().approve(alias, anchor)];
                case 1:
                    result = _c.sent();
                    _a = waitOperation;
                    _b = [client];
                    return [4 /*yield*/, result.op()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                case 3:
                    _c.sent();
                    return [2 /*return*/, JSON.stringify(result, null, 2)];
            }
        });
    });
}
export function markAndRemoveNotificationWrapper(noteId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, markAndRemoveNotification(client, noteId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function revokeCredential(alias, credentialSaid) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.credentials().revoke(alias, credentialSaid, createTimestamp())];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, waitOperation(client, result.op)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function sendRevocationGrants(issuerAlias, credentialSaid, holderAid, holderOobi, verifiers) {
    return __awaiter(this, void 0, void 0, function () {
        var holderGrantSent, verifierResults, err_2, oobiResolved, err_3, err_4, _i, verifiers_1, verifier, oobiResolved, err_5, err_6, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    holderGrantSent = false;
                    verifierResults = [];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.credentials().get(credentialSaid)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error('[sendRevocationGrants] Failed to retrieve credential', credentialSaid, err_2);
                    return [2 /*return*/, {
                            holderGrantSent: false,
                            verifierResults: verifiers.map(function (v) { return ({ aid: v.aid, sent: false, error: 'Credential not found' }); })
                        }];
                case 4:
                    _a.trys.push([4, 12, , 13]);
                    if (!!holderOobi) return [3 /*break*/, 5];
                    console.warn('[sendRevocationGrants] Holder OOBI is not available — skipping holder grant', holderAid);
                    return [3 /*break*/, 11];
                case 5:
                    oobiResolved = false;
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, resolveOobi(client, holderOobi)];
                case 7:
                    _a.sent();
                    oobiResolved = true;
                    return [3 /*break*/, 9];
                case 8:
                    err_3 = _a.sent();
                    console.warn('[sendRevocationGrants] Failed to resolve holder OOBI — skipping holder grant', holderAid, err_3);
                    return [3 /*break*/, 9];
                case 9:
                    if (!oobiResolved) return [3 /*break*/, 11];
                    return [4 /*yield*/, sendCredentialGrant(credentialSaid, issuerAlias, holderAid)];
                case 10:
                    _a.sent();
                    holderGrantSent = true;
                    _a.label = 11;
                case 11: return [3 /*break*/, 13];
                case 12:
                    err_4 = _a.sent();
                    console.error('[sendRevocationGrants] Failed to send holder grant', holderAid, err_4);
                    return [3 /*break*/, 13];
                case 13:
                    _i = 0, verifiers_1 = verifiers;
                    _a.label = 14;
                case 14:
                    if (!(_i < verifiers_1.length)) return [3 /*break*/, 25];
                    verifier = verifiers_1[_i];
                    _a.label = 15;
                case 15:
                    _a.trys.push([15, 23, , 24]);
                    oobiResolved = false;
                    _a.label = 16;
                case 16:
                    _a.trys.push([16, 18, , 19]);
                    return [4 /*yield*/, resolveOobi(client, verifier.oobi)];
                case 17:
                    _a.sent();
                    oobiResolved = true;
                    return [3 /*break*/, 19];
                case 18:
                    err_5 = _a.sent();
                    console.warn('[sendRevocationGrants] Failed to resolve verifier OOBI — skipping grant', verifier.aid, err_5);
                    return [3 /*break*/, 19];
                case 19:
                    if (!oobiResolved) return [3 /*break*/, 21];
                    return [4 /*yield*/, sendCredentialGrant(credentialSaid, issuerAlias, verifier.aid)];
                case 20:
                    _a.sent();
                    verifierResults.push({ aid: verifier.aid, sent: true });
                    return [3 /*break*/, 22];
                case 21:
                    verifierResults.push({ aid: verifier.aid, sent: false, error: 'OOBI resolution failed' });
                    _a.label = 22;
                case 22: return [3 /*break*/, 24];
                case 23:
                    err_6 = _a.sent();
                    errorMessage = err_6 instanceof Error ? err_6.message : String(err_6);
                    console.error('[sendRevocationGrants] Failed to send grant to verifier', verifier.aid, err_6);
                    verifierResults.push({ aid: verifier.aid, sent: false, error: errorMessage });
                    return [3 /*break*/, 24];
                case 24:
                    _i++;
                    return [3 /*break*/, 14];
                case 25: return [2 /*return*/, { holderGrantSent: holderGrantSent, verifierResults: verifierResults }];
            }
        });
    });
}
